import {ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import {EventsService} from '../events/events.service';
import {AuthenticationService} from '../../authentication.service';
import {SeasonsService} from './seasons.service';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {interval, of} from 'rxjs';
import {RaceDetailModalComponent} from '../events/race-detail-modal/race-detail-modal.component';
import {MatDialog, MatTabChangeEvent} from '@angular/material';
import {catchError, mergeMap} from 'rxjs/operators';
import {GlobalService} from '../../global.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UsersService} from '../users/users.service';

@Component({
  selector: 'elastic-seasons',
  templateUrl: './seasons.component.html',
  styleUrls: ['./seasons.component.scss']
})

export class SeasonsComponent implements OnInit, OnDestroy {

  overlaySplit = 1;

  seasons = [];

  selectedSubTab = 0;
  selectedTab = 0;
  sessionDate = '';
  activeSeason = "Season 1";
  selectedSeries = 0;
  menu = 'upcoming';

  upcoming_view = 'split';

  activeRaceDrivers = [];

  event = {};

  language = navigator.language.includes('de') ? 'german' : 'english';

  desktopGap = '24px';
  mobileGap = '16px';

  timer: any;
  timer2: any;

  desktopWidth = `0 0 calc(33.3333% - ${this.desktopGap}`;
  tabletWidth = `0 0 calc(33.3333% - ${this.desktopGap}`;
  smallTabletWidth = `0 0 calc(50% - ${this.mobileGap}`;
  mobileWidth = `0 0 calc(100% - ${this.mobileGap}`;

  constructor( private _eventsService: EventsService,
               private _ngZone: NgZone,
               private cdr: ChangeDetectorRef,
               private auth: AuthenticationService,
               private seasonsService: SeasonsService,
               private globalService: GlobalService,
               private eventsService: EventsService,
               private dialog: MatDialog,
               private router: Router,
               private route: ActivatedRoute,
               private usersService: UsersService) { }

  ngOnInit() {
    if (this.auth.isLoggedIn()) {
      /*if (!this.auth.isLicenseValid()) {
        this.router.navigateByUrl('/invalid-license');
      }*/
    } else {
      this.auth.redirectToLogin();
    }

    this.timer = setInterval(() => {this.cdr.detectChanges();}, 1000);

    if (this.route.snapshot.queryParams['series']) {
      this.selectedSeries = this.route.snapshot.queryParams['series'];
    } else {

      if ( this.auth.getUserLicense() == "ROOKIE" || this.auth.currentUser.safety_rating < 2.5) {
        this.selectedSeries = 2;
      } else {
        if (this.auth.currentUser.safety_rating < 4) {
          this.selectedSeries = 1;
        } else {
          this.selectedSeries = 0;
        }
      }
    }

    this.getData();

    this.timer2 = setInterval(() => {this.checkSlots();}, 30000);

    if (this.route.snapshot.queryParams['series']) {
      this.selectedTab = this.route.snapshot.queryParams['series'];
    } else {
      if (this.auth.currentUser.safety_rating < 4) {
        this.selectedTab = 1;
      }
    }

    if (this.route.snapshot.queryParams['tab2']) {
      this.selectedSubTab = this.route.snapshot.queryParams['tab2'];
    }

    if (this.route.snapshot.queryParams['menu']) {
      this.menu = this.route.snapshot.queryParams['menu'];
    }



  }

  changeEvent() {

  }

  getParticipants(split, event) {

    this.eventsService.getSeasonRaceParticipants(split, event).subscribe( (data: any) => {
      if (data.data.entries) {
        this.activeRaceDrivers = data.data.entries;
        this.cdr.detectChanges();
      }
    });

  }

  getDataForEvent(event_id, index) {

  }

  setExpanded(event, week) {

    this.seasonsService.getEventWeekRaces(event, week).subscribe((data: any) => {
      if (data) {
        this.seasons[0].events.forEach( (ev: any) => {
          if (ev.event_id == event) {
            ev.weeks.forEach( (wk, index) => {
              if (index+1 == week) {
                wk.races = data;
                this.cdr.detectChanges();
              }
            });
          }
        });
      }
    });
  }

  getData() {
    let races = [];
    this.seasonsService.getSeason(this.sessionDate, '', this.selectedSeries).subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:
            const teampSeasons = response.body;

            if (this.seasons.length === 0) {
              this.seasons = response.body;
            }
            console.log("BLA");
            if (teampSeasons[0].events[this.selectedSeries].upcoming.length > 0) {
              console.log("BLA2");

                if (this.sessionDate === '') {
                  this.sessionDate = teampSeasons[0].events[this.selectedSeries].upcomingDates[0].date;
                }

                this.seasons[0].events[this.selectedSeries].upcoming = teampSeasons[0].events[this.selectedSeries].upcoming;
                this.seasons[0].events[this.selectedSeries].upcoming2 = teampSeasons[0].events[this.selectedSeries].upcoming2;

                this.seasons[0].events[this.selectedSeries].upcoming2.forEach((item2, index) => {
                  item2.sessions.forEach((item, index) => {
                    races.push(item.race_id);
                    item.signupCloseDate = new Date(item.signupCloses.replace(' ', 'T') + '+0100');
                    item.serverOpenDate = new Date(item.race_date.replace(' ', 'T') + '+0100');
                    item.signOutCloseDate = new Date(item.signOutCloses.replace(' ', 'T') + '+0100');
                    item.signOutPossible = true;

                    if (item.registered < this.seasons[0].events[this.selectedSeries].split_threshold) {
                      item.slots = this.seasons[0].events[this.selectedSeries].max_split_size * 2;
                    } else {
                      item.slots = (Math.ceil(item.registered / this.seasons[0].events[this.selectedSeries].max_split_size) * this.seasons[0].events[this.selectedSeries].max_split_size);
                    }

                    if (this.seasons[0].events[this.selectedSeries].splits_active == 0) {
                      item.slots = this.seasons[0].events[this.selectedSeries].max_split_size * 1;
                    }


                    if (item.signOutCloseDate < new Date()) {
                      item.signOutPossible = false;
                    }

                    item.signedUp = false;

                    if (item.session_broadcaster > 0) {
                      this.usersService.getUsersData(item.session_broadcaster).subscribe(
                        ( response2: HttpEvent<any> ) => {
                          switch (response2.type) {
                            case HttpEventType.Response:
                              item.broadcaster = response2.body;
                              this.cdr.detectChanges();
                              break;
                          }
                        });
                    }

                    /*
                    if (this.auth.isLoggedIn()) {
                      this.seasonsService.checkSignUp(item.race_id).subscribe(
                        // tslint:disable-next-line:no-shadowed-variable
                        ( response: HttpEvent<any> ) => {
                          switch (response.type) {
                            case HttpEventType.Response:
                              item.signedUp = response.body.success;
                              if (response.body.car_model) {
                                item.car_model = response.body.car_model;
                                item.car = response.body.car;
                                item.split = response.body.split;
                              }
                              break;
                          }
                        });
                    }
                    */

                  });
                });

                if (this.seasons[0].events[this.selectedSeries].recent) {
                  this.seasons[0].events[this.selectedSeries].recent.forEach((item, index) => {
                    item.signupCloseDate = new Date(item.signupCloses.replace(" ","T") + '+0100');
                    item.serverOpenDate = new Date(item.race_date.replace(" ","T") + '+0100');
                  });
                }


              console.log(races);
              this.checkData(races);
              this.changeEvent();

            }

            break;
        }
      });

  }

  checkSlots() {
    let races = [];
    if (this.seasons[0] !== undefined) {
      for (let i = 0; i <= this.seasons[0].events.length; i++) {
        if (this.seasons[0].events[i] !== undefined) {
          this.seasons[0].events[i].upcoming2.forEach((item2, index) => {
            item2.sessions.forEach((item, index) => {
              races.push(item.race_id);
            });
          });

        }
      }
    }
    this.checkData(races);
  }

  checkData(races) {
    this.seasonsService.checkData(races).subscribe(
      (response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Response:
            response.body.forEach( (race) => {

              if (this.seasons !== undefined) {
                for (let i = 0; i <= this.seasons[0].events.length; i++) {
                  if (this.seasons[0].events[i] !== undefined) {
                    this.seasons[0].events[i].upcoming2.forEach((item2, index) => {
                      item2.sessions.forEach((item, index) => {

                        if (item.race_id * 1 === race.race_id * 1) {
                          item.registered = race.slots;
                          if (race.signedUp) {
                            //console.log(race.signedUp);
                            item.signedUp = race.signedUp.success;
                            if (race.signedUp.car_model) {
                              item.car_model = race.signedUp.car_model;
                              item.car = race.signedUp.car;
                              item.split = race.signedUp.split;
                            }
                          }
                        }

                        if (item.registered < this.seasons[0].events[i].split_threshold) {
                          item.slots = this.seasons[0].events[i].max_split_size * 2;
                        } else {
                          item.slots = (Math.ceil(item.registered / this.seasons[0].events[i].max_split_size) * this.seasons[0].events[i].max_split_size);
                        }

                        if (this.seasons[0].events[i].splits_active == 0) {
                          item.slots = this.seasons[0].events[i].max_split_size * 1;
                        }
                      });
                    });

                  }
                }
              }

            });

            this.cdr.detectChanges();
            break;
        }
      });
  }

  backup() {
    /*
    this.seasonsService.getSlots(item.race_id).subscribe(
      // tslint:disable-next-line:no-shadowed-variable
      (response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Response:
            item.registered = response.body.slots;
            this.cdr.detectChanges();
            break;
        }
      });
    if (this.auth.isLoggedIn()) {
      this.seasonsService.checkSignUp(item.race_id).subscribe(
        // tslint:disable-next-line:no-shadowed-variable
        ( response: HttpEvent<any> ) => {
          switch (response.type) {
            case HttpEventType.Response:
              item.signedUp = response.body.success;
              if (response.body.car_model) {
                item.car_model = response.body.car_model;
                item.car = response.body.car;
                item.split = response.body.split;
              }
              break;
          }
        });
    }*/
  }

  openRaceModal(event, race) {

    this.dialog.open(RaceDetailModalComponent, {
      disableClose: false, data: {event_id: event, race_id: race}, minWidth: window.innerWidth - 400, maxWidth: window.innerWidth - 400
    }).afterClosed().subscribe(result => {

    });
  }

  saveBroadcastingSettings(event) {
    this.eventsService.saveBroadcastingSettings(event).subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:
            alert("Settings saved!");
            break;
        }
      });

  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {

    this.selectedTab = tabChangeEvent.index;
    //this.selectedSubTab = 0;

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        series: this.selectedTab
      },
      queryParamsHandling: 'merge',
      // preserve the existing query params in the route
      skipLocationChange: false
      // do not trigger navigation
    });

    this.sessionDate = this.seasons[0].events[this.selectedTab].upcomingDates[0].date;
    this.getData();



  }

  seriesChanged(tabChangeEvent: MatTabChangeEvent): void {

    this.selectedSeries = tabChangeEvent.index;

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        series: tabChangeEvent.index
      },
      queryParamsHandling: 'merge',
      // preserve the existing query params in the route
      skipLocationChange: false
      // do not trigger navigation
    });

    this.sessionDate = this.seasons[0].events[this.selectedSeries].upcomingDates[0].date;
    this.getData();

  }


  menuChange(menu): void {

    this.menu = menu;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        menu: this.menu
      },
      queryParamsHandling: 'merge',
      // preserve the existing query params in the route
      skipLocationChange: false
      // do not trigger navigation
    });

  }


  subTabChanged(tabChangeEvent: MatTabChangeEvent): void {

    this.selectedSubTab = tabChangeEvent.index;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        tab2: this.selectedSubTab
      },
      queryParamsHandling: 'merge',
      // preserve the existing query params in the route
      skipLocationChange: false
      // do not trigger navigation
    });

  }

  broadcast(race_id):void {

    if (confirm('Do you want to broadcast this session?')) {
      this.seasonsService.broadcastSession(race_id).subscribe(
        ( response: HttpEvent<any> ) => {
          switch (response.type) {
            case HttpEventType.Response:
              alert(response.body.message);
              this.getData();
              break;
          }
        });
    }

  }

  loadUpcomming($event) {
    this.sessionDate = $event;
    this.getData();
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
    clearInterval(this.timer2);
  }

  getSeasonData() {



  }

}
